import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory, Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Tooltip from '@mui/material/Tooltip'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import {AssignedContentIcon, PreviewIcon} from 'resources/icons'
import {faFileExport, faInfoCircle} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import create from 'helpers/command'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(assessmentBankBodyStyles)

export default function AssessmentBankBody() {

  const context = useContext(TeacherContext)
  const {quizBankAssessments: assessments} = context

  return (<TableBody>
    {assessments.map(assessment => {
        return <Assessment key={assessment.id} assessment={assessment} />
    })}
  </TableBody>
  )
}

function Assessment ({assessment}) {

  const history = useHistory()
  const context = useContext(TeacherContext)
  const classes = useStyles()
  const {translate, link} = context

  function courseName (id) {
    const {courseName = ""} =  context.institutionCourses.find(({course}) => course == id) || {}
    return courseName
  }

  function typeName (type) {
    const {name = ""} =  context.quizTypes.find(({id}) => id == type) || {}
    return name
  }

  async function handleSave(assessment) {
    const [id] = await create('quiz', 'duplicateAssessment')({id: assessment.id, title: assessment.title})
    context.navigate({tab: 'assessments'},undefined, {query:{id}})
  }

  function assessmentLink(assessment, action, sectionId) {
    return sectionId
      ? link({assessment, action, sectionId}, '/:languageId/:role/:page/:assessment/:action/:sectionId')
      : link({assessment, action}, '/:languageId/:role/:page/:assessment/:action')
  }

  function standardsLink(assessment) {
    return link({assessment, sectionName: 'standards'}, '/:languageId/:role/:page/:tab/:assessment/:sectionName', {preserveQuery: true})
  }

  function handlePreviewClick () {
    context.setState({quizPreviewFrom: '/:languageId/:role/:page/assessment-bank', quizPreviewFromQuery: {...context.query}})
  }


  return (
    <TableRow className={clsx(classes.row)}>
        <TableCell className={clsx(classes.cell, classes.title)} align="left" scope="row">
          <span className={classes.titleContainer}>
            <span className={classes.assessmentIcon}><AssignedContentIcon fill={'#3295ce'} /></span>
            <span className={classes.titleText}>{assessment.title}</span>
          </span>
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.course)} align="left" scope="row">
          {courseName(assessment.course)}
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.type)} align="left" scope="row">
          {translate(`${typeName(assessment.type)}-label`)}
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.unit)} align="left" scope="row">
          {assessment.unit}
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.repository)} align="left" scope="row">
            {translate(`${assessment.repository}`)}
        </TableCell>
        <TableCell className={clsx(classes.cell, classes.actions)} align="right" scope="row">

          <div className={classes.links}>
            <Tooltip title={translate('preview-tooltip')}>
              <Link onClick={handlePreviewClick} to={assessmentLink(assessment.id, 'preview', assessment.firstSection)} className={clsx(classes.link, classes.previewLink)}>
                <PreviewIcon />
              </Link>
            </Tooltip>
            <Tooltip title={translate('standards-tooltip')}>
              <Link to={standardsLink(assessment.id)} className={clsx(classes.link, classes.standardsLink)}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </Link>
            </Tooltip>
            <Tooltip title={translate('save-assessment-tooltip')}>
              <div onClick={()=> handleSave(assessment)} className={clsx(classes.link, classes.duplicateLink)}>
                <FontAwesomeIcon icon={faFileExport} />
              </div>
            </Tooltip>
          </div>
        </TableCell>
    </TableRow>
  )
}

function assessmentBankBodyStyles () {
  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }
  return {
    row: {
      '&:hover': {
        backgroundColor: '#def2ff'
      },
      '&.hidden': {
        display: 'none'
      }
    },
    title: {
      '&.inside': {
        paddingLeft: 25
      }
    },
    titleContainer: {
      display: 'flex'
    },
    assessmentIcon: {
      ...verticalCentering,
      marginTop: -5,
      marginRight: 15
    },
    titleText: {...verticalCentering},
    links: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    link: {
      color: '#009dd8',
      fontSize: '16pt',
      marginRight: 20,
      cursor: 'pointer',
      ...verticalCentering
    },
    sharedLink: {
      display: 'flex',
      marginRight: 20,
      color: '#4d586e'
    },
    sharedIcon: {
      ...verticalCentering,
      color:'#c4c4c4', 
      marginRight: 10,
      '&.shared': {
        color: '#ea8511'
      }
    },
    sharedText: {
      ...verticalCentering,
      cursor: 'default',
      textAlign: 'center',
      marginRight: 10,
      width: 50
    },
    moreSettingsButton: {
      color: '#a2a6b2',
      cursor: 'pointer'
    },
  }
}
